export const STEPS = {
  upload: 1,
  mapping: 2,
  confirmation: 3,
  error: 4,
  success: 5,
};

export const FIELD_IDS = {
  imageName: 'IMAGE_NAME',
  coordinates: 'COORDINATES',
  inspectionDate: 'INSPECTION_DATE',
  siteName: 'SITE_NAME',
  turbineName: 'TURBINE_NAME',
  componentName: 'COMPONENT_UNIQUE_NAME',
  externalId: 'EXTERNAL_ID',
  externalIdSource: 'EXTERNAL_ID_SOURCE',
  inspectionId: 'INSPECTION_ID',
};
